import Router from './router'
import Store from './vuex/store'
//import Api from './api'
import _ from 'lodash';

export default {
    methods: {
        mixinSendMutation: function(type,value)
        {
            Store.commit({
                type: type,
                value: value,
            })
        },

        mixinGoBack()
        {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('mixinGoBack')
            Router.go(-1)
        },

        mixinGoTo: function(routeName,routeParameters)
        {
            if(routeParameters.newWindow)
            {
                let store = window.btoa((JSON.stringify(Store.state))).replace(/[^0-9a-z]/gi, '')
                let routeData = Router.resolve({
                    name: routeName,
                    params: routeParameters,
                    query:{
                        state: store
                    }
                });
                window.open(routeData.href, '_blank')
            }
            else
            {
                Router.push({
                        name: routeName,
                        params: routeParameters
                    }).catch(() => {
                })
            }
        },

        mixinRoundTwoDigits: function(value)
        {
            if(value <= 0) return value // availability può essere -1
            return ((Math.round(value * 100) / 100).toFixed(2))*100/100
        },

        mixinValidateFields: function(refs)
        {
            let fieldCheck = true,
                fieldError = '',
                formCheck = true

            refs.forEach(ref => {

                if(ref.optional && ref.value == '') {
                    if(ref.ref !== undefined)
                    {
                        ref.ref.$el.classList.remove('invalid')
                    }
                    return
                }

                switch (ref.type) {
                    case 'salabam':
                        fieldCheck = ((ref.value).length < 5 | !(/^[a-z0-9]+$/i.test(ref.value))) ? false : true
                        fieldError = 'salabam non valido'
                    break;

                    case 'pin':
                        var pin = (ref.value).replace(/\s/g,'')
                        fieldCheck = (pin.length !== 16 | !(/^[0-9]+$/i.test(pin))) ? false : true
                        fieldError = 'il pin deve essere composto da 16 cifre'
                    break;

                    case 'redeemCode':
                        var redeem = (ref.value).replace(/\s/g,'')

                        // 3118-455-9b3db38cfcc0d5f4
                        var dashs = (redeem.match(/-/g) || []).length; // conto i "-"

                        fieldCheck = (redeem.length >= 20 && dashs == 2) ? true : false

                        fieldError = 'il formato del codice non è corretto'
                    break;

                    case 'discountCode':
                        fieldCheck = ((ref.value).length !== 16) ? false : true
                        fieldError = 'codice buono non valido'
                    break;

                    case 'address':
                        fieldCheck = ((ref.value).length < 4) ? false : true
                        fieldError = 'questo indirizzo non è valido'
                    break;
                    
                    case 'city':
                        fieldCheck = ((ref.value).length < 3 | !(/^[a-zA-Z 'àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+$/.test(ref.value))) ? false : true
                        fieldError = 'questa città non è valida'
                    break;
                    
                    case 'country':
                        fieldCheck = ((ref.value).length < 3 | !(/^[a-zA-Z 'àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+$/.test(ref.value))) ? false : true
                        fieldError = 'questo paese non è valido'
                    break;
                    
                    case 'postalCode':
                        fieldCheck = ((ref.value).length !== 5) ? false : true
                        fieldError = 'il CAP non è valido'
                    break;
                    
                    case 'province':
                        fieldCheck = ((ref.value).length !== 2) ? false : true
                        fieldError = 'la sigla della provincia deve essere formata da due lettere'
                    break;

                    case 'fiscalCode':
                        fieldCheck = ((ref.value).length !== 16) ? false : true
                        fieldError = 'completa o verifica la correttezza del codice'
                    break;

                    case 'email':
                        fieldCheck = (/\S+@\S+\.\S+/.test(ref.value)) ? true : false
                        fieldError = 'questo indirizzo email non è valido'
                    break;

                    case 'emailConfirm':
                        fieldCheck = ref.value
                        fieldError = 'la mail di conferma è diversa da quella inserita'
                    break;

                    case 'firstName':
                        fieldCheck = ((ref.value).length < 3) ? false : true
                        fieldError = 'il nome deve essere composto da almeno tre caratteri'
                    break;

                    case 'lastName':
                        fieldCheck = ((ref.value).length < 3) ? false : true
                        fieldError = 'il cognome deve essere composto da almeno tre caratteri'
                    break;

                    case 'phone':
                        fieldCheck = ((ref.value).length < 4) ? false : true
                        fieldError = 'numero di telefono non valido'
                    break;

                    case 'vat':
                        fieldCheck = ((ref.value).length < 7) ? false : true
                        fieldError = 'partita iva non valido'
                    break;

                    case 'sdi':
                        fieldCheck = ((ref.value).length < 4) ? false : true
                        fieldError = 'codice destinatario non valido'
                    break;

                    case 'checkbox':
                        fieldCheck = (ref.value == true)
                        fieldError = 'questo campo è obbligatorio'
                    break;

                    case 'textarea':
                        fieldCheck = ((ref.value).length < 4) ? false : true
                        fieldError = 'questo campo non può essere vuoto'
                    break;

                    default:
                        fieldCheck = false
                        fieldError = ''
                    break;
                }


                // orValidate
                // per gestire campi che possono essere opzionali
                // a patto che sia valido un'altro campo (o un'insieme di campi)
                if(!fieldCheck && ref.value == '' && ref.orValidate !== undefined){
                  fieldCheck = this.mixinValidateFields(ref.orValidate)
                }

                // TODO (quando necessario) xorValidate validazione esclusiva


                
                if(ref.ref !== undefined)
                {
                    if(fieldCheck)
                    {
                        ref.ref.$el.classList.remove('invalid')
                        fieldError = ''
                    }
                    else
                    {
                        if(ref.value !== '') ref.ref.$el.classList.add('invalid')
                    }

                    if(ref.ref.$el.nextSibling && ref.ref.$el.nextSibling.classList.contains('formError'))
                    {
                        if(ref.value !== '') ref.ref.$el.nextSibling.innerHTML = fieldError
                    }
                }

                formCheck = formCheck && fieldCheck
            });

            return formCheck
        },

        // crea una copia non reattiva di una variabile
        // in js i valori vengono assegnati per riferimento, quindi se si vuole crearne una copia bisogna clonarli
        // questo mixin gestisce sia dati semplici che oggetti
        mixinMakeNonReactiveCopy(original) {

            if (! _.isObject(original) || _.isArray(original)) {

                return original
            }

            let copy = {}
            let attributes = Object.keys(original)
            attributes.forEach(attribute => {
                let attributeValue = Object.getOwnPropertyDescriptor(original, attribute)
                Object.defineProperty(copy, attribute, {
                    __proto__: null,
                    value: attributeValue.get()
                })
            })

            return copy
        },
    },
};